export default __webpack_public_path__ + "static/media/BetterHomeRealty.7afa184e.jpg";